import React from 'react';
import { FilteredStatistics } from '../types';
import LoadingSpinner from './LoadingSpinner';
import './StatsTotalizers.css';

interface StatsTotalizersProps {
  statistics: FilteredStatistics | null;
  loading: boolean;
  error: string | null;
}

const StatsTotalizers: React.FC<StatsTotalizersProps> = ({ statistics, loading, error }) => {
  if (loading) {
    return (
      <div className="stats-totalizers loading">
        <LoadingSpinner message="Carregando estatísticas..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="stats-totalizers error">
        <p>Erro ao carregar estatísticas: {error}</p>
      </div>
    );
  }

  if (!statistics) {
    return null;
  }

  const { sentiment, categories, radios, total } = statistics;

  return (
    <div className="stats-totalizers">
      {/* Total Geral */}
      <div className="stats-section">
        <h3>📊 Total Geral</h3>
        <div className="stats-grid">
          <div className="stat-card total">
            <div className="stat-value">{total.toLocaleString()}</div>
            <div className="stat-label">Total de Análises</div>
          </div>
        </div>
      </div>

      {/* Sentimentos */}
      <div className="stats-section">
        <h3>😊 Sentimentos</h3>
        <div className="stats-grid">
          <div className="stat-card positive">
            <div className="stat-value">{sentiment.positivo.toLocaleString()}</div>
            <div className="stat-label">Positivo</div>
            <div className="stat-percentage">
              {total > 0 ? ((sentiment.positivo / total) * 100).toFixed(1) : 0}%
            </div>
          </div>
          <div className="stat-card negative">
            <div className="stat-value">{sentiment.negativo.toLocaleString()}</div>
            <div className="stat-label">Negativo</div>
            <div className="stat-percentage">
              {total > 0 ? ((sentiment.negativo / total) * 100).toFixed(1) : 0}%
            </div>
          </div>
          <div className="stat-card neutral">
            <div className="stat-value">{sentiment.neutro.toLocaleString()}</div>
            <div className="stat-label">Neutro</div>
            <div className="stat-percentage">
              {total > 0 ? ((sentiment.neutro / total) * 100).toFixed(1) : 0}%
            </div>
          </div>
        </div>
      </div>

      {/* Categorias */}
      {categories.length > 0 && (
        <div className="stats-section">
          <h3>📋 Categorias</h3>
          <div className="stats-grid">
            {categories.map((cat, index) => (
              <div key={index} className="stat-card category">
                <div className="stat-value">{cat.total.toLocaleString()}</div>
                <div className="stat-label">{cat.categoria}</div>
                <div className="stat-percentage">
                  {total > 0 ? ((cat.total / total) * 100).toFixed(1) : 0}%
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Rádios */}
      {radios.length > 0 && (
        <div className="stats-section">
          <h3>📻 Top Rádios</h3>
          <div className="stats-grid">
            {radios.slice(0, 5).map((radio, index) => (
              <div key={index} className="stat-card radio">
                <div className="stat-value">{radio.total.toLocaleString()}</div>
                <div className="stat-label">{radio.radio}</div>
                <div className="stat-percentage">
                  {total > 0 ? ((radio.total / total) * 100).toFixed(1) : 0}%
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatsTotalizers; 